/**
 * Time type values representing overtime classifications.
 *
 * - "reg" = Regular time
 * - "ot" = Overtime
 * - "dot" = Double overtime
 */
export const TimeTypeValues = ["reg", "ot", "dot"] as const;
export type TimeType = (typeof TimeTypeValues)[number];

export const TIME_TYPE_LABELS = {
  reg: "Regular",
  ot: "Overtime",
  dot: "Double overtime",
} satisfies Record<TimeType, string>;

export type TimeTypeNumberMap = {
  reg: number;
  ot: number;
  dot: number;
};

export type TimeTypeNumberMapWithNull = {
  reg: number | null;
  ot: number | null;
  dot: number | null;
};

export type TimeTypeStringMap = {
  reg: string;
  ot: string;
  dot: string;
};

export type TimeTypeStringMapWithNull = {
  reg: string | null;
  ot: string | null;
  dot: string | null;
};

export type TimeTypeMap = TimeTypeNumberMap | TimeTypeStringMap;
export type TimeTypeMapWithNull = TimeTypeNumberMapWithNull | TimeTypeStringMapWithNull;
